import {
  GetPodcastMetricsByDayArgs,
  GetPodcastMetricsByDayResponse,
  getPodcastMetricsByDay,
} from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { usePodcast } from './PodcastContext';
import { metricsQueries } from './queryKeys';
import { podcastMetricsDailyStatsSelector } from './selectors';

type QueryKey = ReturnType<typeof metricsQueries.byDay>;

function useGetPodcastMetricsByDay<TData = GetPodcastMetricsByDayResponse>(
  props: Omit<GetPodcastMetricsByDayArgs, 'podcastId'>,
  opts?: Omit<
    UseQueryOptions<GetPodcastMetricsByDayResponse, unknown, TData, QueryKey>,
    'queryKey' | 'queryFn'
  >,
) {
  const { podcastId: id } = usePodcast();

  return useQuery<GetPodcastMetricsByDayResponse, unknown, TData, QueryKey>(
    metricsQueries.byDay({
      podcastId: id as string,
      ...props,
    }),
    ({ queryKey: [{ startMillis, endMillis, remoteEpisodeId, podcastId }] }) =>
      getPodcastMetricsByDay({
        podcastId: podcastId as string,
        startMillis,
        endMillis,
        remoteEpisodeId,
      }),

    { enabled: !!id, ...opts },
  );
}

export function useDailyPodcastMetrics(
  args: Omit<GetPodcastMetricsByDayArgs, 'podcastId'>,
) {
  return useGetPodcastMetricsByDay(args, {
    select: podcastMetricsDailyStatsSelector,
  });
}
